//import { HttpError } from './http-error'
import axios from "axios"
import querystring from 'querystring'
import store from '../../store'
export class Http {
    constructor() {
    }

    async postForm(url = '', data = {}, options = {}) {
        let authHeader = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        const opt = {
            ...options, headers: { ...options.headers, ...authHeader }
        };
        try {
            return await axios.post(url, querystring.stringify(data), opt);
        }
        catch (e) {
            if(e.response.status==401){
                store.commit('app_settings/set_unauthorized_panel_visible', true);
            }
            let res = { data: e.response.data };
            throw res;
        }
    }
    async request(options = {}) {
        try {
            return await axios(options);
        }
        catch (e) {
            if(e.response.status==401){
                store.commit('app_settings/set_unauthorized_panel_visible', true);
            }
            let res = { data: e.response.data };
            throw res;
        }
    }
    async get(url = '', options = {}) {
        const opt = {
            ...options
        };
        try {
            return await axios.get(url, opt);
        }
        catch (e) {
            if (e.response.status == 401) {
                store.commit('app_settings/set_unauthorized_panel_visible', true);
            }
            let res = { data: e.response.data };
            throw res;
        }
    }
    async post(url = '', data = {}, options = {}) {
        const opt = {
            ...options
        };
        try {
            return await axios.post(url, data, opt);
        }
        catch (e) {
            if (e.response.status == 401) {
                store.commit('app_settings/set_unauthorized_panel_visible', true);
            }
            let res = { data: e.response.data };
            throw res;
        }
    }
    async put(url = '', data = {}, options = {}) {
        const opt = {
            ...options
        };
        try {
            return await axios.put(url, data, opt);
        }
        catch (e) {
            
            if (e.response.status == 401) {
                store.commit('app_settings/set_unauthorized_panel_visible', true);
            }
            let res = { data: e.response.data };
            throw res;
        }
    }
    async delete(url = '', options = {}) {
        const opt = {
            ...options
        };
        try {
            return await axios.delete(url, opt);
        }
        catch (e) {
            if (e.response.status == 401) {
                store.commit('app_settings/set_unauthorized_panel_visible', true);
            }
            let res = { data: e.response.data };
            throw res;
        }
    }
}
